import { FC } from 'react'
import { Attachment, AttachmentProps } from 'stream-chat-react'

import { CustomGallery } from './CustomGallery'
import { CustomImage } from './CustomImage'

export const CustomAttachment: FC<AttachmentProps> = (props) => {
  return <Attachment {...props} Image={CustomImage} Gallery={CustomGallery} />
}
